// EmailJS configuration loaded from environment variables (CRA - REACT_APP_* prefix)
export const emailConfig = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || "",
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "",
  visitorTemplateId: process.env.REACT_APP_EMAILJS_VISITOR_TEMPLATE_ID || "",
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "",
};

export const isContactEmailConfigured =
  !!(emailConfig.serviceId && emailConfig.templateId && emailConfig.publicKey);

export const isVisitorEmailConfigured =
  !!(emailConfig.serviceId && emailConfig.visitorTemplateId && emailConfig.publicKey);
